import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"

// Toast notifications
import toastr from "toastr"
import "toastr/build/toastr.min.css"

// Redux
import { Link, useParams, useLocation } from "react-router-dom"
import withRouter from "../../components/Common/withRouter"

import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

// Login Redirect Utility
import { handleLoginClose, getLoginRedirectPath, clearLoginRedirectPath } from "../../utils/loginRedirect"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// Social Login (Google OAuth)
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google"
// import TwitterLogin from "react-twitter-auth"
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"
import googleIcon from "../../assets/images/Frame.png"
// import metaIcon from "../../assets/images/meta-logo.png" // Meta login temporarily disabled
import { X } from 'lucide-react';


// actions
import {
  loginUser,
  activateAccount,
  guestLogin,
} from "../../store/actions"

// import images
//import logo from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import logo from "../../assets/images/brands/trivium logo.jpg"
import logodark from "../../assets/images/download1.png"
//Import config
import { google } from "../../config"
import { api } from "../../utils/variables"
import axios from "axios"
import { useNavigate } from "react-router-dom";
import mainlogo from "../../assets/images/new_web_logo.png";

const Login = props => {
  document.title = " Login | Keyquest"
  const navigate = useNavigate();

  const { token } = useParams()
  const location = useLocation()
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState("signin")
  const [showPassword, setShowPassword] = useState(false)
  const [loginLoading, setLoginLoading] = useState(false)
  const [guestLoading, setGuestLoading] = useState(false)
  const [rememberMe, setRememberMe] = useState(false)
  const [showComingSoon, setShowComingSoon] = useState(false)

  // Load remembered email on component mount
  useEffect(() => {
    const rememberedEmail = localStorage.getItem('userEmail')
    const rememberedState = localStorage.getItem('rememberMe') === 'true'

    if (rememberedEmail && rememberedState) {
      validation.setFieldValue('email', rememberedEmail)
      setRememberMe(true)
    }
  }, [])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // email: "norexe1389@cironex.com" || "",
      // password: "qwerty123" || "",
      email: "",
      password: "",
      rememberMe: false,
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: values => {
      // const username = values.email.split('@')[0];
      dispatch({ type: "LOGIN_ERROR_CLEAR" })

      // Handle remember me functionality
      if (rememberMe) {
        localStorage.setItem('rememberMe', 'true')
        localStorage.setItem('userEmail', values.email)
      } else {
        localStorage.removeItem('rememberMe')
        localStorage.removeItem('userEmail')
      }

      // Only send the initial chatbot prompt if this is the user's first
      // login after sign-up AND the login email matches the verified email.
      const firstLoginFlag = localStorage.getItem('firstLoginPrompt') === 'true'
      const firstLoginEmail = localStorage.getItem('firstLoginPromptEmail') || ''
      const shouldSendInitialPrompt = firstLoginFlag && firstLoginEmail === values.email

      const storedRedirectPath = getLoginRedirectPath()
      const redirectTo = storedRedirectPath !== '/' ? storedRedirectPath : null

      // Clear the stored path once we have it
      clearLoginRedirectPath()

      if (shouldSendInitialPrompt) {
        // Don't remove the flag here — only clear it after a successful login in the saga.
        dispatch(loginUser(values, props.router.navigate, "/chatbot", "Welcome me as a new user on keyquest and give a brief description about the platform?"))
          .finally(() => {
            setLoginLoading(false) // Stop loading
          })
      } else {
        dispatch(loginUser(values, props.router.navigate, redirectTo)).finally(() => {
          setLoginLoading(false)
        })
      }
    },
    // onSubmit: async values => {
    //   try {
    //     // Make the API call to login
    //     const response = await axios.post(`${api}/user/login`, {
    //       email: values.email,
    //       password: values.password,
    //     })
    //     // Get the token from the response and store it in sessionStorage
    //     const accessToken = response.data.access_token
    //     sessionStorage.setItem("accessToken", accessToken)

    //     // Redirect to the dashboard or another authenticated page
    //     props.router.navigate("/dashboard")
    //   } catch (error) {
    //     console.error("Login failed", error)
    //     alert("Invalid login credentials.")
    //   }
    // },
  })

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    error: login.error,
  }))

  const { error } = useSelector(LoginProperties)

  //handleGoogleLoginResponse for @react-oauth/google
  const googleResponse = async (response) => {
    try {
      const idToken = response && (response.credential || response.tokenId)
      if (!idToken) {
        toastr.error("Invalid Google response", "Login Error!")
        return
      }
      const res = await axios.post(`${api}/user/google-login`, { id_token: idToken })
      const accessToken = res?.data?.access_token
      if (!accessToken) {
        toastr.error("Failed to retrieve access token", "Login Error!")
        return
      }
      try {
        const email = res?.data?.email || ""
        const userName = email ? (email.split("@")[0] || "") : ""
        localStorage.setItem("authToken", accessToken)
        if (email) localStorage.setItem("userEmail", email)
        if (userName) localStorage.setItem("userName", userName)
        localStorage.setItem("authUser", JSON.stringify(res?.data || {}))
      } catch (e) { }
      const storedPath = getLoginRedirectPath()
      if (storedPath && storedPath !== '/') {
        clearLoginRedirectPath()
        props.router.navigate(storedPath)
      } else {
        props.router.navigate("/dashboard")
      }
    } catch (err) {
      const msg = err?.response?.data?.error || "Google login failed"
      toastr.error(msg, "Login Error!")
    }
  }

  //handleMetaLoginResponse - now handled by onclick redirect
  // const facebookResponse = response => {
  //   signIn(response, "facebook")
  // }

  useEffect(() => {
    document.body.className = "authentication-bg"
    // remove classname when component will unmount

    return function cleanup() {
      document.body.className = ""
    }
  })

  useEffect(() => {
    // Toast configuration is centralized in `src/utils/toast.js` and applied at app startup

    // Prefer navigation state messages (transient). Fallback to sessionStorage for compatibility.
    const navState = (location && location.state) || {}

    if (navState.registrationSuccess) {
      toastr.success(navState.registrationSuccess, "Registration Successful!")
    } else {
      const successMessage = sessionStorage.getItem('registrationSuccess')
      if (successMessage) {
        toastr.success(successMessage, "Registration Successful!")
        try { sessionStorage.removeItem('registrationSuccess') } catch (e) { }
      }
    }

    if (navState.verificationSuccess) {
      toastr.success(navState.verificationSuccess, "Account Verified!")
    } else {
      const verificationSuccessMsg = sessionStorage.getItem('verificationSuccess')
      if (verificationSuccessMsg) {
        toastr.success(verificationSuccessMsg, "Account Verified!")
        try { sessionStorage.removeItem('verificationSuccess') } catch (e) { }
      }
    }

    if (navState.verificationError) {
      toastr.error(navState.verificationError, "Verification Failed!")
    } else {
      const verificationErrorMsg = sessionStorage.getItem('verificationError')
      if (verificationErrorMsg) {
        toastr.error(verificationErrorMsg, "Verification Failed!")
        try { sessionStorage.removeItem('verificationError') } catch (e) { }
      }
    }

    // Defensive: remove chatbot body class left behind if any
    try { document.body.classList.remove('chatbot-initial-prompt') } catch (e) { }

    // Clear navigation state so messages don't persist if user navigates without refresh
    try {
      if (location && location.state) {
        navigate(location.pathname, { replace: true, state: {} })
      }
    } catch (e) { }
  }, [])

  useEffect(() => {
    if (error) {
      setLoginLoading(false)
      if (error === "User is not active. Please activate your account") {
        // Automatically trigger activation email without showing toast
        dispatch(activateAccount(validation.values.email))
      } else if (error === "Activation link sent to your mail") {
        toastr.success("Activation email sent! Please check your inbox and click the activation link.", "Activation Email Sent!")
      } else if (error === "Activation failed. Please try again later.") {
        toastr.error("Failed to send activation email. Please try again later.", "Activation Failed!")
      } else {
        toastr.error(error, "Login Error!")
      }
    }
  }, [error, validation.values.email, dispatch])

  return (
    <React.Fragment>
      <div className="modern-auth-container">
        <div className="auth-modal">
          {/* Close button */}
          <div className="close-button">
            <button
              onClick={() => handleLoginClose(navigate)}
              className="close-icon"
              aria-label="Close login"
            >
              <X />
            </button>
          </div>

          {/* Header */}
          <div className="auth-header">
            <div className="logo-container">
              <img src={mainlogo} alt="KeyQuest" className="logo-image" />
            </div>
            <h1 className="auth-title">Welcome Back!</h1>
            <p className="auth-subtitle">Sign in to access your gaming analytics dashboard</p>
          </div>

          {/* Tabs */}
          <div className="auth-tabs">
            <button
              className={`tab-button ${activeTab === 'signin' ? 'active' : ''}`}
              onClick={() => setActiveTab('signin')}
            >
              Sign In
            </button>
            <Link to="/register" className="tab-button">
              Sign Up
            </Link>
          </div>

          {/* Form */}
          <div className="auth-form">
            <Form
              className="form-horizontal form-horizontal-login"
              onSubmit={e => {
                e.preventDefault()
                setLoginLoading(true)

                // Validate the form manually
                validation.validateForm().then((errors) => {
                  if (Object.keys(errors).length === 0) {
                    // Form is valid, proceed with submission
                    validation.handleSubmit()
                  } else {
                    // Form has validation errors, reset loading state and show errors
                    setLoginLoading(false)
                    // Set touched state to show errors
                    validation.setTouched({
                      email: true,
                      password: true
                    })
                  }
                })
                return false
              }}
            >
              {/* Removed activate account button */}

              <div className="form-group">
                <Label className="form-label">Email Address</Label>
                <Input
                  name="email"
                  className={`form-input ${validation.touched.email && validation.errors.email ? 'is-invalid' : ''}`}
                  placeholder="Enter your email"
                  type="email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email || ""}
                />
                {validation.touched.email && validation.errors.email && (
                  <FormFeedback type="invalid" className="error-message">
                    {validation.errors.email}
                  </FormFeedback>
                )}
              </div>

              <div className="form-group">
                <Label className="form-label">Password</Label>
                <div className="password-input-container">
                  <Input
                    name="password"
                    value={validation.values.password || ""}
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    className={`form-input password-input ${validation.touched.password && validation.errors.password ? 'is-invalid' : ''}`}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i className={`mdi ${showPassword ? 'mdi-eye-off' : 'mdi-eye'}`}></i>
                  </button>
                </div>
                {validation.touched.password && validation.errors.password && (
                  <FormFeedback type="invalid" className="error-message">
                    {validation.errors.password}
                  </FormFeedback>
                )}
              </div>

              <div className="form-options">
                <div className="remember-me">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="rememberMe"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="rememberMe">
                    Remember me
                  </label>
                </div>
                <Link to="/forgot-password" className="forgot-password">
                  Forgot password?
                </Link>
              </div>

              <div className="form-submit">
                {loginLoading ? (
                  <button className="submit-button loading" type="submit" disabled>
                    <Spinner color="white" size="sm" />
                  </button>
                ) : (
                  <button className="submit-button" type="submit">
                    Sign in
                  </button>
                )}
                <div className="guest-box">
                  <button
                    type="button"
                    className="guest-button"
                    onClick={() => {
                      setGuestLoading(true)
                      dispatch(guestLogin(props.router.navigate, "/dashboard"))
                        .finally?.(() => setGuestLoading(false))
                        // Note: saga doesn't return a promise in standard flow without resolve/reject handling,
                        // but setting loading to true is enough for visual feedback before redirect.
                    }}
                    disabled={guestLoading}
                  >
                    {guestLoading ? <Spinner color="white" size="sm" /> : "Login as Guest"}
                  </button>
                </div>
              </div>
            </Form>
          </div>

          {/* Social Login */}

          <div className="separator">
            <span>Or continue with</span>
          </div>
          <div className="social-login">


            <div className="social-buttons">
              <GoogleOAuthProvider clientId={google.CLIENT_ID || ""}>
                <div className="google-button-wrapper">
                  <button type="button" className="social-button google-button">
                    <span className="google-icon">
                      <img src={googleIcon} alt="Google" />
                    </span>
                    <span className="google-text">Google</span>
                  </button>
                  <div className="google-overlay">
                    <GoogleLogin
                      onSuccess={googleResponse}
                      onError={() => { toastr.error("Google sign-in failed", "Login Error!") }}
                      useOneTap={false}
                    />
                  </div>
                </div>
              </GoogleOAuthProvider>
              {/* Meta login button temporarily disabled
              <button
                className="social-button meta-button"
                onClick={() => {
                  setShowComingSoon(true)
                }}
              >
                <span className="meta-icon">
                  <img src={metaIcon} alt="Meta" />
                </span>
                <span className="meta-text">
                  Meta
                </span>
              </button>
              */}
            </div>
          </div>

          {/* Terms */}
          <div className="terms-section">
            <p className="terms-text">
              By continuing, you agree to our{" "}
              <Link to="/terms" className="terms-link">Terms of Service</Link>
              {" "}and{" "}
              <Link to="/privacy" className="terms-link">Privacy Policy.</Link>
            </p>
          </div>
        </div>
      </div>

      {/* Coming Soon Modal */}
      <Modal isOpen={showComingSoon} toggle={() => setShowComingSoon(false)} centered className="coming-soon-modal">
        <ModalHeader toggle={() => setShowComingSoon(false)}>
          <span className="coming-soon-title">Coming Soon</span>
        </ModalHeader>
        <ModalBody>
          <div className="coming-soon-content">
            <div className="coming-soon-icon">
              <i className="mdi mdi-timer-sand"></i>
            </div>
            <p className="coming-soon-text">We’re working hard to enable this option. Please check back shortly.</p>
            <button type="button" className="coming-soon-btn" onClick={() => setShowComingSoon(false)}>Okay</button>
          </div>
        </ModalBody>
      </Modal>

      <style jsx>{`
        .form-horizontal-login .form-input {
          padding: 0 16px;
          height: 40px;
          border-radius: 8px;
          border: 1px solid #353748;
        }

        .form-horizontal-login .form-group {
          margin-bottom: 16px;
        }

        .form-horizontal-login .form-submit .submit-button {
          padding: 10px 0;
          margin-bottom: 24px;
        }

        .modern-auth-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
          padding: 20px;
          position: relative;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }

        .auth-modal {
          background: #21222d;
          border-radius: 16px;
          padding: 32px;
          width: 100%;
          max-width: 480px;
          position: relative;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
          border: 1px solid #353748;
        }

        .close-button {
          position: absolute;
          top: 20px;
          right: 20px;
        }

        .close-icon {
          color: #a1acb8;
          font-size: 24px;
          text-decoration: none;
          line-height: 1;
          background: none;
          border: none;
          padding: 0;
          cursor: pointer;
          transition: all 0.2s;
        }

        .close-icon:hover {
          background: #3a3a3a;
          color: white;
        }

        .auth-header {
          text-align: center;
          margin-bottom: 24px;
        }

        .logo-container {
          margin-bottom: 8px;
          text-align: center;
        }

        .logo-image {
          width: 185px;
          height: auto;
          object-fit: contain;
          padding-bottom: 15px;
        }

        .auth-title {
          color: #fff;
          font-size: 28px;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .auth-subtitle {
          color: #e8e8e8;
          font-size: 16px;
          margin: 0;
        }

        .auth-tabs {
          display: flex;
          background: #1a1a1a;
          border-radius: 8px;
          padding: 4px;
          margin-bottom: 24px;
          width: 100%;
          border: 1px solid #353748;
        }

        .tab-button {
          flex: 1;
          background: transparent;
          border: none;
          color: #888;
          padding: 12px 24px;
          border-radius: 6px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          font-size: 14px;
          text-decoration: none;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .tab-button:hover {
          color: #ccc;
          text-decoration: none;
        }

        .tab-button.active {
          background: #f6255a;
          color: white;
          font-weight: 600;
          font-size: 16px;
        }

        .tab-button:not(.active) {
          color: #888;
          font-weight: 400;
        }

        .form-group {
          margin-bottom: 20px;
          width: 100%;
        }

        .form-label {
          color: #e8e8e8;
          margin-bottom: 8px;
          display: block;
          font-family: Rubik;
          font-weight: 500;
          font-size: 14px;
          line-height: 21px;
        }

        .form-input {
          width: 100%;
          height: 40px;
          border-width: 1px;
          border-radius: 8px;
          padding: 12px 16px;
          background: #1a1a1a !important;
          color: #ffffff !important;
        }

        .form-input::placeholder {
          color: #666 !important;
          font-family: Rubik;
          font-weight: 400;
          font-size: 16px;
          line-height: 1;
        }

        /* Force white text even when browser autofill applies its own styles */
        input.form-input:-webkit-autofill,
        input.form-input:-webkit-autofill:focus,
        input.form-input:-webkit-autofill:hover {
          -webkit-text-fill-color: #ffffff !important;
          -webkit-box-shadow: 0 0 0px 1000px #1a1a1a inset !important;
          box-shadow: 0 0 0px 1000px #1a1a1a inset !important;
        }

        input.form-input:-moz-autofill,
        input.form-input:-moz-autofill:focus {
          -moz-text-fill-color: #ffffff !important;
          box-shadow: 0 0 0px 1000px #1a1a1a inset !important;
        }

        .password-input,
        .form-input.password-input {
          color: #ffffff !important;
        }

        .form-input:focus {
          border: 1px solid #353748;
          box-shadow: 0 0 0 2px rgba(233, 30, 99, 0.2) !important;
          outline: none !important;
        }

        .password-input-container {
          position: relative;
        }

        .password-input {
          padding-right: 50px !important;
        }

        .password-toggle {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: #666;
          cursor: pointer;
          font-size: 16px;
          padding: 4px;
        }

        .form-options {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
          width: 100%;
          gap: 8px;
        }

        .remember-me {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .form-check-input {
          width: 16px !important;
          height: 16px !important;
          background: #ffffff !important;
          border: 1px solid #666666 !important;
          border-radius: 2px !important;
          margin: 0 !important;
          flex-shrink: 0;
          cursor: pointer;
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          position: relative;
        }

        .form-check-input:checked {
          background: #ff3366 !important;
          border-color: #ff3366 !important;
        }

        .form-check-input:checked::after {
          content: "✓";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 12px;
          font-weight: bold;
          line-height: 1;
        }

        .form-check-input:hover {
          border-color: #ff3366 !important;
        }

        /* Place guest button directly under sign-in with 1px gap */
        .form-submit {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1px;
          width: 100%;
        }

        .guest-box {
          margin: -5px 0 14px 0;
          display: flex;
          justify-content: center;
          width: 100%;
        }

        .guest-button {
          background: transparent;
          border: 1px solid #444;
          color: #ddd;
          padding: 6px 10px;
          border-radius: 8px;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.15s;
          min-width: 150px;
        }

        .guest-button:hover {
          background: rgba(255, 255, 255, 0.03);
          border-color: #f6255a;
          color: #fff;
        }

        .form-check-label {
          color: #e8e8e8 !important;
          font-size: 14px !important;
          font-weight: 400 !important;
          font-family: Rubik !important;
          margin: 0 !important;
          line-height: 21px !important;
          display: flex;
          align-items: center;
        }

        .forgot-password {
          color: #f6255a;
          text-decoration: none;
          font-size: 14px;
          font-weight: 500;
          display: flex;
          align-items: center;
        }

        .forgot-password:hover {
          text-decoration: underline;
        }

        .submit-button {
          width: 100%;
          background: #e91e63;
          border: none;
          color: white;
          padding: 14px 16px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          margin-bottom: 18px;
          min-width: 84px;
          max-width: 480px;
        }

        .submit-button:hover {
          background: #f6255a;
        }

        .submit-button.loading {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .social-login {
          margin-top: 24px;
        }

        .separator {
          text-align: center;
          margin: 0 0 24px 0;
          position: relative;
          font-family: Rubik;
          font-weight: 400;
          font-size: 16px;
          line-height: 1;
        }

        .separator::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 1px;
          background: #333;
        }

        .separator span {
          padding: 0 16px;
          color: #e8e8e8;
          font-size: 14px;
          position: relative;
          background: #21222d;
        }

        .social-buttons {
          display: flex;
          gap: 16px;
          margin-bottom: 24px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .google-button-wrapper {
          position: relative;
          display: inline-block;
        }

        .google-button {
          min-width: 188px;
          height: 40px;
        }

        .google-overlay {
          position: absolute;
          inset: 0;
          opacity: 0;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .social-button {
          background: #1a1a1a;
          border: 1px solid #333;
          border-radius: 20px;
          padding: 10px 16px;
          color: white;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 188px;
          height: 40px;
          justify-content: center;
        }

        .social-button:hover {
          background: #2a2a2a;
          border-color: #444;
        }

        .google-icon {
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .google-icon img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .google-text {
          font-family: Rubik;
          font-weight: 600;
          font-size: 16px;
          line-height: 1;
          color: #ffffff;
        }

        /* Meta login styles temporarily disabled
        .meta-icon {
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .meta-icon img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .meta-text {
          font-family: Rubik;
          font-weight: 600;
          font-size: 16px;
          line-height: 21px;
          color: #ffffff;
        }
        */

        .terms-section {
          margin-top: 20px;
          text-align: center;
        }

        .terms-text {
          color: #e8e8e8;
          font-size: 14px;
          margin: 0;
          line-height: 1.5;
        }

        .terms-link {
          color: #e91e63;
          text-decoration: none;
        }

        .terms-link:hover {
          text-decoration: underline;
        }

        @media (max-width: 480px) {
          .modern-auth-container {
            padding: 16px;
          }

          .auth-modal {
            padding: 20px;
            margin: 0;
          }

          .auth-title {
            font-size: 24px;
          }

          .auth-subtitle {
            font-size: 14px;
          }

          .form-options {
            flex-direction: column;
            align-items: flex-start;
          }

          .social-buttons {
            flex-direction: column;
            align-items: stretch;
          }

          .social-button,
          .google-button {
            width: 100%;
            min-width: 0;
          }
        }

        /* Coming Soon modal styling to match layout */
        .coming-soon-modal .modal-content {
          background: #21222d;
          border: 1px solid #353748;
          border-radius: 16px;
          color: #fff;
        }

        .coming-soon-modal .modal-header {
          border-bottom: 1px solid #353748;
          background: #21222d;
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
        }

        .coming-soon-title {
          color: #ffffff;
          font-size: 18px;
          font-weight: 700;
        }

        .coming-soon-modal .modal-body {
          background: #21222d;
          padding: 24px;
        }

        .coming-soon-content {
          text-align: center;
        }

        .coming-soon-icon {
          width: 64px;
          height: 64px;
          margin: 0 auto 12px auto;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(246, 37, 90, 0.12);
          color: #f6255a;
          font-size: 28px;
        }

        .coming-soon-text {
          color: #e8e8e8;
          font-size: 14px;
          margin: 8px 0 16px 0;
          line-height: 1.5;
        }

        .coming-soon-btn {
          width: 100%;
          background: #e91e63;
          border: none;
          color: white;
          padding: 12px 16px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
        }

        .coming-soon-btn:hover {
          background: #f6255a;
        }

        /* Error message styling */
        .error-message {
          color: #dc3545 !important;
          font-size: 12px !important;
          margin-top: 4px !important;
          display: block !important;
          font-family: Rubik !important;
          font-weight: 400 !important;
        }

        .form-input.is-invalid {
          border-color: #dc3545 !important;
          box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2) !important;
        }

        .form-input.is-invalid:focus {
          border-color: #dc3545 !important;
          box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2) !important;
        }

        /* Custom toast styling for dark theme */
        #toast-container > .toast {
          background-color: #21222d !important;
          color: #fff !important;
          border: 1px solid #353748 !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
        }

        #toast-container > .toast-success {
          background-color: #21222d !important;
          border-color: #28a745 !important;
          border-left: 4px solid #28a745 !important;
        }

        #toast-container > .toast-error {
          background-color: #21222d !important;
          border-color: #dc3545 !important;
          border-left: 4px solid #dc3545 !important;
        }

        #toast-container > .toast-info {
          background-color: #21222d !important;
          border-color: #f6255a !important;
          border-left: 4px solid #f6255a !important;
        }

        #toast-container > .toast-warning {
          background-color: #21222d !important;
          border-color: #ffc107 !important;
          border-left: 4px solid #ffc107 !important;
          color: #212529 !important;
        }

        .toast-close-button {
          color: #fff !important;
          opacity: 0.8 !important;
        }

        .toast-close-button:hover {
          opacity: 1 !important;
        }
      `}</style>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}
